import { render, staticRenderFns } from "./GoToPropertiesButton.vue?vue&type=template&id=10bf5360"
import script from "./GoToPropertiesButton.vue?vue&type=script&lang=js"
export * from "./GoToPropertiesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports